import './pricing-check-group.css';

import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import type { SafeHtml } from 'kerfjs';
import { RefreshCcwDot } from 'lucide';

import { currentPricingCheckState } from '../../../data/pricing-prompt.js';
import { PRICING_CHECK_SHORT_LABEL } from '../../../lib/pricing-check-control.js';

/** Stable pricing-check action used by the production main toolbar: a green,
 *  labelled "Price Check" Kerf button (HS2-CNXFTE). Its full state label is the
 *  tooltip, and a disabled button uses that reason as its accessible name.
 *  Button owns its success color, spinner, disabled state, and busy semantics;
 *  the app-owned wrapper announces the running transition (HS2-5RTQ6F). */
export function PricingCheckGroup({ view: v }: { view: string }): SafeHtml {
  const state = currentPricingCheckState(v);
  if (!state.visible) return <></>;
  return (
    <div
      class="pricing-check-group"
      role="group"
      aria-label="Pricing Check"
      aria-busy={state.running ? 'true' : 'false'}
    >
      <Button
        tone="success"
        emphasis="primary"
        size="default"
        shape="pill"
        action="run-analysis"
        disabled={state.disabled ? true : undefined}
        loading={state.running}
        ariaLabel={state.disabled ? state.label : undefined}
        title={state.label}
        icon={<LucideIcon icon={RefreshCcwDot} name="" />}
      >
        {PRICING_CHECK_SHORT_LABEL}
      </Button>
      {state.running ? (
        <span class="pricing-check-status" role="status" aria-live="polite">
          Running pricing check
        </span>
      ) : null}
    </div>
  );
}
